import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

type Props = { to: string };
const FABBackButton = (props: Props) => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        position: 'absolute',
        top: '5rem',
        left: '3rem',
        borderRadius: '50%',
        cursor: 'pointer'
      }}
      onClick={() => navigate(props.to)}
    >
      <Button
        style={{ height: '55px', width: '55px' }}
        className='d-flex flex-row justify-content-center align-items-center'
      >
        <i className='fa-solid fa-chevron-left' style={{ fontSize: 25, color: 'white', fontWeight: 'bold' }}></i>
      </Button>
    </div>
  );
};

export default FABBackButton;
